import type { FormatDateOptions } from '@common/i18n';
import { dayjs } from '@libs';

type DateEntry = {
  month: string;
  day: string;
  date: dayjs.Dayjs;
};

type GroupDatesByMonthArgs = {
  dates: string[];
  formatDate: (
    value: string | number | Date | undefined,
    opts?: FormatDateOptions | undefined
  ) => string;
};

export function groupDatesByMonth({
  dates,
  formatDate,
}: GroupDatesByMonthArgs): [string, string[]][] {
  const daysByMonth = new Map<string, DateEntry[]>();

  for (const rawDate of dates) {
    const date = dayjs(rawDate, 'DD/MM/YYYY').utcOffset(0);

    if (!date.isValid()) continue;

    const month = formatDate(date.toDate(), { month: 'long' });
    const day = date.format('DD');

    if (!daysByMonth.has(month)) {
      daysByMonth.set(month, []);
    }

    daysByMonth.get(month)?.push({ month, day, date });
  }

  return Array.from(daysByMonth.entries())
    .map(([month, entries]) => {
      const sortedEntries = [...entries].sort(
        (a, b) => a.date.valueOf() - b.date.valueOf()
      );

      const days = sortedEntries.map(({ day }) => day);

      return {
        month,
        days,
        firstDate: sortedEntries[0]?.date,
      };
    })
    .sort((a, b) => a.firstDate.valueOf() - b.firstDate.valueOf())
    .map(({ month, days }) => [month, days]);
}
